var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundCrossGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9399_1247)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#C9CDD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9897 17.6394L20.9497 22.5994C21.1805 22.8302 21.4533 22.9445 21.7679 22.9421C22.0826 22.9397 22.3571 22.8214 22.5914 22.5871C22.8257 22.3527 22.9434 22.0789 22.9444 21.7656C22.9454 21.4524 22.8305 21.1803 22.5996 20.9495L17.6396 15.9895L22.7072 10.9219C22.9409 10.6881 23.0586 10.4139 23.0602 10.0993C23.0618 9.78464 22.9469 9.51161 22.7155 9.28022C22.4841 9.04882 22.2117 8.93459 21.8984 8.93754C21.5851 8.94049 21.3116 9.05882 21.0779 9.29256L16.0103 14.3602L11.0502 9.4001C10.8194 9.16929 10.5467 9.05507 10.232 9.05743C9.91738 9.0598 9.64289 9.17815 9.40857 9.41248C9.17424 9.6468 9.05658 9.92061 9.05559 10.2339C9.05459 10.5472 9.1695 10.8192 9.40032 11.05L14.3604 16.0101L9.29278 21.0777C9.05904 21.3114 8.94138 21.5856 8.93979 21.9003C8.9382 22.2149 9.0531 22.4879 9.2845 22.7193C9.5159 22.9507 9.78824 23.0649 10.1015 23.062C10.4148 23.059 10.6883 22.9407 10.9221 22.707L15.9897 17.6394Z",
    fill: "#C9CDD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9399_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCrossGrey);
export default __webpack_public_path__ + "static/media/round_cross_grey.78d9ac962605695126d0480fc1b2824c.svg";
export { ForwardRef as ReactComponent };